import React from 'react';
import { withTranslation } from 'react-i18next';
import { createReservation } from '../../../models/reservation';
import { getAttendants } from '../../../models/attendant';
import { Alert } from 'reactstrap';

import Button from '../../../components/button';

class ResExcludedAttendant extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      attendants: null,
      excludedAttendants: {},
      error: null
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.retrieveAttendants();
    let existingExcludedAttendants = this.props.reservation.user.excludedAttendants;
    let excludedAttendants = {};
    if(existingExcludedAttendants.length){
      existingExcludedAttendants.forEach(exc => {
        excludedAttendants[exc.attendantId] = true;
      })
    }
    this.setState({excludedAttendants});
  }

  retrieveAttendants() {
    getAttendants().then(
      (result) => {
        this.setState({
          attendants: result     
        });
      },
      (error) => {
        this.setState({ error });
      }
    );
  }

  handleChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? (target.checked?1:0) : target.value;
    let excludedAttendants = this.state.excludedAttendants;
    let attendantId = target.id;
      if(value){
        excludedAttendants[attendantId] = attendantId;
      } else {
        if(attendantId in excludedAttendants) delete excludedAttendants[attendantId]
      }
      this.setState({excludedAttendants});
  }

  handleSubmit(e) {
    e.preventDefault();
    let res = this.props.reservation;
    res.replacingReservationId = res.reservationId;
    res.excludedAttendantIDs = Object.keys(this.state.excludedAttendants);
    createReservation(res)
      .then(res => {
        this.props.handleUpdateReservation(res);
        this.props.toggle();
      }, error => {
        this.setState({
          error,
          isSubmitting: false,
        })
      });
  }

  render() {
    const { t } = this.props;
    const { error, attendants, excludedAttendants } = this.state;
      return attendants?
          <div className="col-12">
          {error?<Alert color="danger">{t(error)}</Alert>:null}
          <form autoComplete="off" onSubmit={this.handleSubmit} >
            <div className="form-group row">
              {attendants.map((att, i) => {
                return <div className="form-check">
                <input type="checkbox" className="form-check-input" checked={att.id in excludedAttendants} id={att.id} name="attendantIds" onChange={this.handleChange} /> 
                <label htmlFor={att.id} className="form-check-label input-wrap pie-4 w-100">
                  {att.name}
                </label>
              </div>
              })}
            </div>
            <div className="text-end">
              <Button className="mx-auto btn-secondary" large>{t("Submit")}</Button>
            </div>
          </form>
        </div>
      :null
  }
}

export default withTranslation()(ResExcludedAttendant);